import { TranslationsContext } from '@teliaee/telia-translate';
import { observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Collapse, Grid, GridColumn } from 'telia-front-react';
import GravityForm from '../../forms/GravityForm';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import LanguageStore from '../../stores/LanguageStore';
import { SEGMENT_BUSINESS } from '../../stores/SegmentStore';

export interface RequestFasterInternetProps {
  partner: boolean;
  calculatorKey: string;
  renderInsteadOfCardSelection?: boolean;
  languageStore?: LanguageStore;
  internetCalculatorStore?: InternetCalculatorStore;
}

@observer
class RequestFasterInternet extends React.Component<RequestFasterInternetProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  @observable accessor showHeaderLabel: boolean = true;

  private get formName() {
    const { partner, calculatorKey, internetCalculatorStore } = this.props;
    const partnerFormName = internetCalculatorStore.getState(calculatorKey).propState.betterPartnerFormName;
    const formName = this.props.renderInsteadOfCardSelection
      ? internetCalculatorStore.getState(calculatorKey).propState.betterInternetOnTeliaNetworkFormName
      : internetCalculatorStore.getState(calculatorKey).propState.betterInternetFormName;

    if (partnerFormName && partner) {
      return partnerFormName;
    }
    if (!partner && formName) {
      return formName;
    }
  }

  private handleSubmitSuccess = () => {
    runInAction(() => {
      this.showHeaderLabel = false;
    });
  };

  public render() {
    const translate = this.context.translate;
    const { internetCalculatorStore, calculatorKey } = this.props;
    const cmsDataStoreKeys = internetCalculatorStore.getCmsStoreKeys(calculatorKey);
    const segment = internetCalculatorStore.getState(calculatorKey).propState.segment;
    if (!this.formName) {
      return null;
    }

    const formGrid = (renderInsteadOfCardSelection?: boolean) => (
      <Grid align={[renderInsteadOfCardSelection ? 'start-xs' : 'center-xs']}>
        <GridColumn width={['md-10', 'lg-8', 'xl-6']}>
          <GravityForm
            name={this.formName}
            fieldValueProviders={[
              {
                data: cmsDataStoreKeys.addressKey,
                technicalParameter: 'internet_address'
              },
              {
                data: cmsDataStoreKeys.addressIdKey,
                technicalParameter: 'internet_address_id'
              },
              {
                data: cmsDataStoreKeys.roomKey,
                technicalParameter: 'internet_room'
              },
              {
                data: cmsDataStoreKeys.buildingIdKey,
                technicalParameter: 'internet_building_id'
              },
              {
                data: cmsDataStoreKeys.apartmentIdKey,
                technicalParameter: 'internet_apartment_id'
              },
              {
                data: cmsDataStoreKeys.plannedInternetKey,
                technicalParameter: 'internet_package'
              }
            ]}
            onSubmitSuccess={this.handleSubmitSuccess}
            submitButtonProps={{ type: renderInsteadOfCardSelection ? 'primary' : undefined }}
            cmsData={internetCalculatorStore.getCmsData(calculatorKey)}
          />
        </GridColumn>
      </Grid>
    );

    if (this.props.renderInsteadOfCardSelection) {
      return formGrid(true);
    }

    return (
      <Collapse color={'grey'}>
        {this.showHeaderLabel && (
          <h3>
            {translate(
              segment === SEGMENT_BUSINESS ? 'internetAndTvCalculator.elektrileviInternet.orderForm.header.B2B' : 'internetAndTvCalculator.wishFasterInternet'
            )}
          </h3>
        )}
        {formGrid()}
      </Collapse>
    );
  }
}

export default inject('languageStore', 'internetCalculatorStore')(RequestFasterInternet);
